export default{
    'backHome':'返回首页',
    'liveOver':'主播已下线',
    'loginTip': '首次登录/注册请先输入原始密码888888',
    'loginTip2': '您没有绑定展商，请联系本公司管理员把您添加为子账号'
}